import { Col, Divider, Row, Statistic } from 'antd';
import React, { useEffect, useState } from 'react';

import useFetch from '../hooks/fetcher';

const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

type StatisticResponseType = {
    general: { table_name: string; quantity: string }[];
    herb_association: { table_name: string; quantity: string }[];
    recipe_association: { table_name: string; quantity: string }[];
};

interface StringObjectKey {
    [index: string]: string;
}

const generalNaming: StringObjectKey = {
    unique_botanical_name: 'Accepted botanical name',
    botanical_synonym: 'Botanical synonyms',
    botanical_common_name: 'Common plant names',
    tcm_info: 'Herbs',
    recipes_detail_info: 'Recipes',
    unique_ingredients: 'Ingredients',
    targets_detail_andrean: 'Targets',
    tcm_disease: 'Diseases',
};

const herbNaming: StringObjectKey = {
    plant_ingredients_association: 'Herb-ingredient associations',
    ingredient_pathways: 'Ingredient-pathway associations',
    plant_pathways: 'Herb-pathway associations',
};

const recipeNaming: StringObjectKey = {
    recipe_ingredients: 'Recipe-ingredient associations',
    recipe_pathways: 'Recipe-pathway associations',
    // plant_pathways: 'Recipe-KEGG pathway associations',
};

const PageStatistics: React.FC = () => {
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const [result, setResult] = useState<StatisticResponseType>();

    useEffect(() => {
        get('/api/statistic.php', {}).then((r) => setResult(r));
    }, []);

    return (
        <div>
            <Divider orientation="left" style={{ color: '#1890ff' }}>
                General numbers
            </Divider>
            <Row justify="space-around" style={{ marginBottom: '10vh', maxWidth: '900px' }}>
                {result?.general.map((item, idx) => {
                    return (
                        <Col style={{ width: '200px', padding: '20px' }} key={idx}>
                            <Statistic title={generalNaming[item.table_name]} value={item.quantity} />
                        </Col>
                    );
                })}
            </Row>
            <Divider orientation="left" style={{ color: '#1890ff' }}>
                Herb association information
            </Divider>
            <Row justify="space-around" style={{ marginBottom: '10vh', maxWidth: '900px' }}>
                {result?.herb_association.map((item, idx) => {
                    return (
                        <Col style={{ width: '200px', padding: '20px' }} key={idx}>
                            <Statistic title={herbNaming[item.table_name]} value={item.quantity} />
                        </Col>
                    );
                })}
            </Row>
            <Divider orientation="left" style={{ color: '#1890ff' }}>
                Recipes association information
            </Divider>
            <Row justify="space-around" style={{ marginBottom: '10vh', maxWidth: '900px' }}>
                {result?.recipe_association.map((item, idx) => {
                    return (
                        <Col style={{ width: '200px', padding: '20px' }} key={idx}>
                            <Statistic title={recipeNaming[item.table_name]} value={item.quantity} />
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default PageStatistics;
